/**
 * 50音表の行の並びと、覚える用（ヒント付き）画像の有無。
 */

export type FingerspellingRow = { label: string; ids: readonly string[] };

/** 紙の表のように、行ごとに並べる。1行は最大5つ（5列のグリッド） */
export const FINGERSPELLING_ROWS: readonly FingerspellingRow[] = [
  { label: "あ", ids: ["a", "i", "u", "e", "o"] },
  { label: "か", ids: ["ka", "ki", "ku", "ke", "ko"] },
  { label: "さ", ids: ["sa", "shi", "su", "se", "so"] },
  { label: "た", ids: ["ta", "chi", "tsu", "te", "to"] },
  { label: "な", ids: ["na", "ni", "nu", "ne", "no"] },
  { label: "は", ids: ["ha", "hi", "fu", "he", "ho"] },
  { label: "ま", ids: ["ma", "mi", "mu", "me", "mo"] },
  { label: "や", ids: ["ya", "yu", "yo"] },
  { label: "ら", ids: ["ra", "ri", "ru", "re", "ro"] },
  { label: "わ", ids: ["wa", "wo", "n"] },
  {
    label: "きごう",
    ids: ["dakuten", "handakuten", "small-ya", "small-yu", "small-yo"],
  },
  { label: "きごう", ids: ["small-tsu", "choon"] },
];

/** 覚える用の画像がない id（記号は手の形ではなく動きなので、ヒントを重ねられない） */
const WITHOUT_YURAI_HINT: ReadonlySet<string> = new Set([
  "dakuten",
  "handakuten",
  "small-ya",
  "small-yu",
  "small-yo",
  "small-tsu",
  "choon",
]);

export const hasYuraiHint = (id: string): boolean =>
  !WITHOUT_YURAI_HINT.has(id);
